import styled from "@emotion/styled";
import { colorGuide, colorPalette } from "../../theme/colors";

export const TabsContainer = styled.div`
  display: inline-flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: ${colorGuide.lightComponents.secondaryTab.bgColor};
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1) inset;
  width: 100%;
`;

export const TabsWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  position: relative;
`;

export const TabItem = styled.button<{
  isActive: boolean;
  disabled?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  justify-content: center;
  box-shadow: ${(props) =>
    props.isActive ? "0px 1px 4px 0px rgba(0, 0, 0, 0.1)" : ""};

  border: none;
  background: ${(props) =>
    props.isActive
      ? colorGuide.lightComponents.secondaryTab.tabItem.active.bgColor
      : colorGuide.lightComponents.secondaryTab.tabItem
          .bgColor}; /* Active background */
`;
